import React from "react";

const TasksIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.81 2C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2H7.81Z"
        fill="#3D68FF"
      />
      <path
        d="M17.5605 9.62109H12.3105C11.9005 9.62109 11.5605 9.28109 11.5605 8.87109C11.5605 8.46109 11.9005 8.12109 12.3105 8.12109H17.5605C17.9805 8.12109 18.3105 8.46109 18.3105 8.87109C18.3105 9.28109 17.9805 9.62109 17.5605 9.62109Z"
        fill="white"
      />
      <path
        d="M7.72055 10.1486C7.57055 10.2986 7.38055 10.3686 7.19055 10.3686C7.00055 10.3686 6.80055 10.2986 6.66055 10.1486L5.91055 9.39859C5.61055 9.10859 5.61055 8.62859 5.91055 8.33859C6.20055 8.04859 6.67055 8.04859 6.97055 8.33859L7.19055 8.55859L8.91055 6.83859C9.20055 6.54859 9.67055 6.54859 9.97055 6.83859C10.2605 7.12859 10.2605 7.60859 9.97055 7.89859L7.72055 10.1486Z"
        fill="white"
      />
      <path
        d="M17.5605 16.6211H12.3105C11.9005 16.6211 11.5605 16.2811 11.5605 15.8711C11.5605 15.4611 11.9005 15.1211 12.3105 15.1211H17.5605C17.9805 15.1211 18.3105 15.4611 18.3105 15.8711C18.3105 16.2811 17.9805 16.6211 17.5605 16.6211Z"
        fill="white"
      />
      <path
        d="M7.72055 17.1486C7.57055 17.2986 7.38055 17.3686 7.19055 17.3686C7.00055 17.3686 6.80055 17.2986 6.66055 17.1486L5.91055 16.3986C5.61055 16.1086 5.61055 15.6286 5.91055 15.3386C6.20055 15.0486 6.67055 15.0486 6.97055 15.3386L7.19055 15.5586L8.91055 13.8386C9.20055 13.5486 9.67055 13.5486 9.97055 13.8386C10.2605 14.1286 10.2605 14.6086 9.97055 14.8986L7.72055 17.1486Z"
        fill="white"
      />
    </svg>
  );
};

export default TasksIcon;
